import React from "react";
import { layoutStyle } from "../layout-ui/style";
import { Grid, TextField, Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { rowData } from "../../common/constants/gridRowColumn";

export const AddFleetList = () => {
  const classes = layoutStyle();
  const navigation = useNavigate();
  const { register, handleSubmit } = useForm();
  const handleSave = (e) => {
    let row = [...rowData];
    let payload = {
      ...e,
      id: rowData.length + 1,
    };
    row.push(payload);

    navigation("/current-fleet-details", { state: { data: row } });
  };
  return (
    <Box className={classes.mainContent}>
      <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          alignItems: "center",
        }}
      >
        <h3>Add Current Fleet Details</h3>
        <Button
          className={classes.addFleetListButton}
          onClick={handleSubmit(handleSave)}
        >
          Save
        </Button>
      </Box>
      <Grid container>
        <form>
          <Grid
            container
            lg={12}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Grid item lg={4}>
              <TextField
                style={{ width: "90%", margin: "5px" }}
                type="text"
                label="Name"
                variant="outlined"
                {...register("name")}
              />
              <TextField
                style={{ width: "90%", margin: "5px" }}
                type="text"
                label="Age"
                variant="outlined"
                {...register("age")}
              />
              <TextField
                style={{ width: "90%", margin: "5px" }}
                type="text"
                label="Year"
                variant="outlined"
                {...register("year")}
              />
              <TextField
                style={{ width: "90%", margin: "5px" }}
                type="text"
                label="Make"
                variant="outlined"
                {...register("make")}
              />
              <TextField
                style={{ width: "90%", margin: "5px" }}
                type="text"
                label="Model"
                variant="outlined"
                {...register("model")}
              />
            </Grid>
            <Grid item lg={4}>
              <TextField
                style={{ width: "90%", margin: "5px" }}
                type="text"
                label="Fuel"
                variant="outlined"
                {...register("fuel")}
              />
              <TextField
                style={{ width: "90%", margin: "5px" }}
                type="text"
                label="Type"
                variant="outlined"
                {...register("type")}
              />
              <TextField
                style={{ width: "90%", margin: "5px" }}
                type="text"
                label="Drive Train"
                variant="outlined"
                {...register("driveTrain")}
              />
              <TextField
                style={{ width: "90%", margin: "5px" }}
                type="text"
                label="CPM Category"
                variant="outlined"
                {...register("cpmCategory")}
              />
              <TextField
                style={{ width: "90%", margin: "5px" }}
                type="text"
                label="MPG"
                variant="outlined"
                {...register("mpg")}
              />
            </Grid>
            <Grid item lg={4}>
              <TextField
                style={{ width: "90%", margin: "5px" }}
                type="number"
                label="VIN"
                variant="outlined"
                {...register("vin")}
              />
              <TextField
                style={{ width: "90%", margin: "5px" }}
                type="text"
                label="Driver Name"
                variant="outlined"
                {...register("driverName")}
              />
              <TextField
                style={{ width: "90%", margin: "5px" }}
                type="number"
                label="Total Miles"
                variant="outlined"
                {...register("totalMiles")}
              />
              <TextField
                style={{ width: "90%", margin: "5px" }}
                type="number"
                label="Annual Miles"
                variant="outlined"
                {...register("annualMilege")}
              />
              <TextField
                style={{ width: "90%", margin: "5px" }}
                type="number"
                label="Monthly Miles"
                variant="outlined"
                {...register("monthlyMilege")}
              />
            </Grid>
          </Grid>
        </form>
      </Grid>
    </Box>
  );
};
